//
//
//
//
//
//

export default {
  name: 'App',
  data(){
    return {
      gap_time: 0,
      beforeUnload_time: 0,
    };
  },
  methods:{
    // 关闭窗口之前执行
    beforeunloadHandler() {
      this.beforeUnload_time = new Date().getTime();
    },
    unloadHandler() {
      this.gap_time = new Date().getTime() - this.beforeUnload_time;
      //判断是窗口关闭还是刷新 毫秒数判断
      if (this.gap_time <= 10) {
        localStorage.removeItem("first_utm_source");
      }
    },
  },
  mounted(){
    // 监听浏览器关闭
    window.addEventListener("beforeunload", () => this.beforeunloadHandler());
    //关闭浏览器
    window.addEventListener("unload", () => this.unloadHandler());

    localStorage.removeItem('wxCodeUrl')
    localStorage.setItem('wxCodeUrl',location.href.split('#')[0])
  }
}



// WEBPACK FOOTER //
// ./src/App.vue